import { SearchFormData } from '@/features/approving_invoice_reports/components/Search/hooks/useSearchForm';
import { PropsControl } from '@/features/approving_invoice_reports/components/Search/type';
import { useTranslation } from '@/i18n';
import {
  FormDatepicker,
  type DatepickerProps,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

export const DateRangeSelect: FC<PropsControl> = memo(
  ({ control, name, labelProps }) => {
    const { t } = useTranslation();
    const datepickerProps: DatepickerProps = useMemo(
      () => ({
        placeholder: [t('date_gteq_placeholder'), t('date_lteq_placeholder')],
        size: 'small',
      }),
      [t]
    );

    const labelPropsFunc = useMemo(() => {
      return {
        ...labelProps,
      };
    }, [labelProps]);

    return (
      <FormDatepicker<SearchFormData>
        control={control}
        name={name}
        inputId={name}
        datepickerProps={datepickerProps}
        label={labelPropsFunc}
        testId={name}
      />
    );
  }
);
DateRangeSelect.displayName = 'DateRangeSelect';
